import useSWR from "swr";

import * as fetcher from "../fetcher";
import { type NbaType } from "./types";

export interface NbaObject {
  done: boolean;
  nbaId: string;
  nbaType: NbaType;
  priority: number;
  context?: {
    appointment_no?: string;
  };
}

export const useNBA = (opportunityId?: number) => {
  return useSWR<NbaObject[]>(
    opportunityId ? `/opportunity/${opportunityId}/nbas` : null,
    () => fetcher.opportunity.get(`/${opportunityId}/nbas`),

    { revalidateOnFocus: true, keepPreviousData: true }
  );
};
